import React from "react";
import {
  Box,
  Text,
  Image,
  VStack,
  Flex,
  Button,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
} from "@chakra-ui/react";
import { BIZFLEX_README_DOCS_BASE } from "../../components/common/constants";

const ApiSupport = () => {
  const faqs = [
    {
      question: "What can I build with BizFlex APIs?",
      answer:
        "You can build fintech apps, marketplaces, or payment platforms with collections, payouts, wallets, and card capabilities.",
    },
    {
      question: "Do I need a business account to access the API",
      answer:
        "Yes. You’ll need to create a BizFlex Business Account to access live credentials and go live.",
    },
    {
      question: "Is BizFlex compliant with regulatory standards?",
      answer:
        "Absolutely. BizFlex is NDPR compliant and partnered with licensed financial institutions.",
    },
    {
      question: "How soon can I go live?",
      answer:
        "Once KYC and compliance checks are complete, you can move to production within days.",
    },
  ];

  return (
    <Box
      bg="#ffffff"
      w="100%"
      py={{ base: "60px", md: "100px" }}
      px={{ base: "20px", md: "80px", lg: "120px" }}
    >
      <VStack spacing="60px" align="center" w="100%">
        {/* Top Section */}
        <VStack spacing="24px" align="center" w="100%" maxW="1200px">
          <Button
            as="a"
            href={BIZFLEX_README_DOCS_BASE}
            target="_blank"
            rel="noopener noreferrer"
            display="flex"
            alignItems="center"
            gap="10px"
            w="fit-content"
            bg="#EFF6FF"
            color="#2463EB"
            px="20px"
            py="12px"
            border="1px solid #93C5FD"
            borderRadius="999px"
            fontSize="15px"
            fontWeight={600}
            _hover={{ bg: "#DBEAFE" }}
          >
            <Box
              w="28px"
              h="28px"
              borderRadius="50%"
              bg="#2463EB"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Image
                src="assets/symbol.svg"
                alt=""
                w="14px"
                h="14px"
                filter="brightness(0) invert(1)"
              />
            </Box>
            Support
          </Button>

          <Text
            fontSize={{ base: "26px", md: "44px" }}
            fontWeight={600}
            textAlign="center"
            color="#0F172B"
            lineHeight={{ base: "38.4px", md: "57.6px" }}
          >
            Frequently Asked Questions
          </Text>

          <Text
            fontSize={{ base: "14px", md: "18px" }}
            textAlign="center"
            color="#64748B"
            maxW="700px"
            lineHeight={{ base: "21px", md: "27px" }}
          >
            Everything you need to know about BizFlex APIs
          </Text>
        </VStack>

        {/* FAQ Accordion */}
        <Box w="100%" maxW="1200px">
          <Accordion allowToggle>
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                border="1px solid #E0E0E0"
                borderRadius="8px"
                mb="16px"
                bg="#ffffff"
              >
                <AccordionButton
                  py="20px"
                  px="24px"
                  _hover={{ bg: "transparent" }}
                  _expanded={{
                    bg: "transparent",
                    borderBottom: "1px solid #E2E8F0",
                  }}
                >
                  <Box flex="1" textAlign="left">
                    <Text
                      fontSize={{ base: "14px", md: "15px" }}
                      fontWeight={400}
                      color="#0F172B"
                    >
                      {faq.question}
                    </Text>
                  </Box>
                  <AccordionIcon color="#2463EB" />
                </AccordionButton>
                <AccordionPanel pb="20px" px="24px" pt="0">
                  <Text
                    fontSize={{ base: "14px", md: "16px" }}
                    color="#64748B"
                    lineHeight="24px"
                  >
                    {faq.answer}
                  </Text>
                </AccordionPanel>
              </AccordionItem>
            ))}
          </Accordion>
        </Box>

        {/* Still have questions Section - match Figma */}
        <Box
          w="100%"
          maxW="1200px"
          bg="#F4F8FC"
          border="1px solid #93C5FD"
          borderRadius="16px"
          p={{ base: "28px", md: "48px" }}
        >
          <VStack spacing="28px" align="center" w="100%">
            <Text
              fontSize={{ base: "26px", md: "32px" }}
              fontWeight={700}
              textAlign="center"
              color="#0F172B"
              lineHeight={{ base: "1.3", md: "1.3" }}
            >
              Still have questions?
            </Text>

            <Text
              fontSize={{ base: "14px", md: "16px" }}
              textAlign="center"
              color="#64748B"
              lineHeight={{ base: "1.5", md: "1.5" }}
            >
              Our team is here to help you get started
            </Text>

            <Flex
              direction={{ base: "column", md: "row" }}
              gap="16px"
              w="100%"
              justify="center"
              align="center"
            >
              <Button
                as="a"
                href="mailto:api-support@bizflex.africa"
                bg="#2463EB"
                borderRadius="12px"
                h="56px"
                w={{ base: "100%", md: "260px" }}
                px="24px"
                color="#fff"
                fontWeight={600}
                fontSize="16px"
                display="flex"
                alignItems="center"
                justifyContent="center"
                gap="10px"
                _hover={{ bg: "#1a4fc7" }}
              >
                <Image src="assets/email.svg" alt="" w="20px" h="20px" />
                Contact Support
              </Button>

              <Button
                as="a"
                href="https://calendly.com/fastamoni-product/30min"
                target="_blank"
                rel="noopener noreferrer"
                bg="#FFFFFF"
                borderRadius="12px"
                h="56px"
                w={{ base: "100%", md: "260px" }}
                px="24px"
                color="#0F172B"
                border="1px solid #93C5FD"
                fontWeight={600}
                fontSize="16px"
                display="flex"
                alignItems="center"
                justifyContent="center"
                gap="10px"
                _hover={{ bg: "#EFF6FF" }}
              >
                <Image src="assets/date.svg" alt="" w="20px" h="20px" />
                Schedule a Demo
              </Button>
            </Flex>
          </VStack>
        </Box>
      </VStack>
    </Box>
  );
};

export default ApiSupport;

